(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const testimonialCards = document.querySelectorAll('.testimonialCard');
    const carouselWrapper = document.querySelector('.testimonialCardsWrapper');
    const prevBtn = document.querySelector('.carousel-nav-prev');
    const nextBtn = document.querySelector('.carousel-nav-next');
    const swipeIndicators = {
      left: document.querySelector('.swipe-indicator-left'),
      right: document.querySelector('.swipe-indicator-right')
    };
    
    if (testimonialCards.length === 0) return;

    // Update scroll indicators
    function updateScrollIndicators() {
      if (!carouselWrapper) return;
      
      const canScrollLeft = carouselWrapper.scrollLeft > 0;
      const canScrollRight = carouselWrapper.scrollLeft < (carouselWrapper.scrollWidth - carouselWrapper.clientWidth - 10);
      
      if (canScrollLeft) {
        carouselWrapper.classList.add('can-scroll-left');
      } else {
        carouselWrapper.classList.remove('can-scroll-left');
      }
      
      if (canScrollRight) {
        carouselWrapper.classList.add('can-scroll-right');
      } else {
        carouselWrapper.classList.remove('can-scroll-right');
      }
      
      // Update navigation buttons - hide when at edges
      if (prevBtn) {
        if (canScrollLeft) {
          prevBtn.style.display = 'flex';
          prevBtn.disabled = false;
        } else {
          prevBtn.style.display = 'none';
          prevBtn.disabled = true;
        }
      }
      if (nextBtn) {
        if (canScrollRight) {
          nextBtn.style.display = 'flex';
          nextBtn.disabled = false;
        } else {
          nextBtn.style.display = 'none';
          nextBtn.disabled = true;
        }
      }
    }


    // Navigation button handlers
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (!carouselWrapper) return;
        const cardWidth = testimonialCards[0] ? testimonialCards[0].offsetWidth + 25 : 345;
        carouselWrapper.scrollBy({
          left: -cardWidth,
          behavior: 'smooth'
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (!carouselWrapper) return;
        const cardWidth = testimonialCards[0] ? testimonialCards[0].offsetWidth + 25 : 345;
        carouselWrapper.scrollBy({
          left: cardWidth,
          behavior: 'smooth'
        });
      });
    }

    // Scroll event listeners
    if (carouselWrapper) {
      carouselWrapper.addEventListener('scroll', function() {
        updateScrollIndicators();
      });
      
      // Initial update
      updateScrollIndicators();
    }

    // Video functionality
    testimonialCards.forEach(function(card) {
      const video = card.querySelector('video');
      const playButton = card.querySelector('.playButton');
      const overlay = card.querySelector('.overlay');
      const progressFill = card.querySelector('.video-progress-fill');
      
      if (!video || !playButton) return;
      
      // Prevent carousel drag from starting when clicking on interactive elements
      const preventDrag = function(e) {
        e.stopPropagation();
      };
      
      playButton.addEventListener('mousedown', preventDrag);
      overlay.addEventListener('mousedown', preventDrag);
      const roundBtn = card.querySelector('.button.round');
      if (roundBtn) {
        roundBtn.addEventListener('mousedown', preventDrag);
      }

      // Update progress bar
      function updateProgress() {
        if (!progressFill || !video) return;
        if (video.duration) {
          const progress = (video.currentTime / video.duration) * 100;
          progressFill.style.width = progress + '%';
        }
      }

      // Function to toggle video play/pause
      const toggleVideo = function(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
        
        // Pause all other videos
        testimonialCards.forEach(function(otherCard) {
          if (otherCard !== card) {
            const otherVideo = otherCard.querySelector('video');
            if (otherVideo) {
              otherVideo.pause();
              otherCard.classList.remove('playing');
            }
          }
        });
        
        // Play current video
        if (video.paused || video.ended) {
          video.play().then(function() {
            card.classList.add('playing');
            // Start progress updates
            if (progressFill) {
              video.addEventListener('timeupdate', updateProgress);
            }
          }).catch(function(error) {
            console.error('Error playing video:', error);
            video.load();
            video.play().then(function() {
              card.classList.add('playing');
              if (progressFill) {
                video.addEventListener('timeupdate', updateProgress);
              }
            }).catch(function(err) {
              console.error('Error playing video after load:', err);
            });
          });
        } else {
          video.pause();
          card.classList.remove('playing');
          if (progressFill) {
            video.removeEventListener('timeupdate', updateProgress);
          }
        }
      };
      
      // Play button click handler
      playButton.addEventListener('click', toggleVideo, true);
      
      // Video element clicks
      video.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleVideo(e);
      }, true);
      
      // Round button clicks
      const roundButtonEl = card.querySelector('.button.round');
      if (roundButtonEl) {
        roundButtonEl.addEventListener('click', function(e) {
          toggleVideo(e);
        }, true);
      }

      // Video ended handler
      video.addEventListener('ended', function() {
        card.classList.remove('playing');
        video.currentTime = 0;
        if (progressFill) {
          progressFill.style.width = '0%';
          video.removeEventListener('timeupdate', updateProgress);
        }
      });

      // Video pause handler
      video.addEventListener('pause', function() {
        if (video.currentTime > 0 && !video.ended) {
          card.classList.remove('playing');
        }
        if (progressFill) {
          video.removeEventListener('timeupdate', updateProgress);
        }
      });

      // Click on overlay to pause/play
      overlay.addEventListener('click', function(e) {
        if (e.target.closest('.button.round')) {
          return;
        }
        toggleVideo(e);
      }, true);
    });

    // Smooth scroll behavior for carousel
    if (carouselWrapper) {
      let isDown = false;
      let startX;
      let scrollLeft;
      let hasMoved = false;

      carouselWrapper.addEventListener('mousedown', function(e) {
        const isInteractiveElement = e.target.closest('.playButton') || 
            e.target.closest('.overlay') || 
            e.target.closest('video') ||
            e.target.closest('.button.round') ||
            e.target.closest('.overlayFooter') ||
            e.target.closest('.social-actions') ||
            e.target.closest('.profile-header') ||
            e.target.closest('.platform-badge');
        
        if (isInteractiveElement) {
          return;
        }
        
        isDown = true;
        hasMoved = false;
        carouselWrapper.style.cursor = 'grabbing';
        startX = e.pageX - carouselWrapper.offsetLeft;
        scrollLeft = carouselWrapper.scrollLeft;
      });

      carouselWrapper.addEventListener('mouseleave', function() {
        isDown = false;
        carouselWrapper.style.cursor = 'grab';
      });

      carouselWrapper.addEventListener('mouseup', function(e) {
        isDown = false;
        hasMoved = false;
        carouselWrapper.style.cursor = 'grab';
      });

      carouselWrapper.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        
        const x = e.pageX - carouselWrapper.offsetLeft;
        const walk = Math.abs(x - startX);
        
        if (walk > 5) {
          hasMoved = true;
          e.preventDefault();
          const scrollWalk = (x - startX) * 2;
          carouselWrapper.scrollLeft = scrollLeft - scrollWalk;
        }
      });

      // Touch support for mobile
      let touchStartX = 0;
      let touchScrollLeft = 0;
      let touchHasMoved = false;

      carouselWrapper.addEventListener('touchstart', function(e) {
        if (e.target.closest('.playButton') || 
            e.target.closest('.overlay') || 
            e.target.closest('video') ||
            e.target.closest('.button.round') ||
            e.target.closest('.social-actions')) {
          touchStartX = 0;
          return;
        }
        
        touchStartX = e.touches[0].pageX - carouselWrapper.offsetLeft;
        touchScrollLeft = carouselWrapper.scrollLeft;
        touchHasMoved = false;
      }, { passive: true });

      carouselWrapper.addEventListener('touchmove', function(e) {
        if (!touchStartX) return;
        
        const x = e.touches[0].pageX - carouselWrapper.offsetLeft;
        const walk = Math.abs(x - touchStartX);
        
        if (walk > 10) {
          touchHasMoved = true;
          const scrollWalk = (x - touchStartX) * 1.5;
          carouselWrapper.scrollLeft = touchScrollLeft - scrollWalk;
        }
      }, { passive: true });
      
      carouselWrapper.addEventListener('touchend', function() {
        touchStartX = 0;
        touchHasMoved = false;
      }, { passive: true });

      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          updateScrollIndicators();
        }, 250);
      });
    }
  });
})();
